import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../base/models'
import { IPkRateGroup } from '../models/models'

export class ListPkRatesApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/pesineKontrat/listRates',
      requesterInfo,
    })
  }

  public async listRates(): Promise<IPkRateGroup[]> {
    return await this.getAsync<IPkRateGroup[]>()
  }
}
